// components/ProductSelector/index.js
import ProductSelector from './ProductSelector'
import './ProductSelector.css'

export default ProductSelector
export { ProductSelector }